window.assignmentReactionActionFormatter = function(value, row) {
    let html = '';
    if (row.raw_status != 'pending') {
        return html;
    }
    html += '<a class="button-accept button btn btn-success btn-sm me-3" data-id="'+row.id+'">';
    html += '<i class="fal fa-check"></i>';
    html += __('Accepteren');
    html += '</a>';
    html += '<a class="button-reject button btn btn-danger btn-sm" data-id="'+row.id+'">';
    html += '<i class="fal fa-times"></i>';
    html += __('Afwijzen');
    html += '</a>';
    return html;
};
